import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useDropzone } from "react-dropzone";
import { FilePlus, File, XCircle } from "react-feather";
import AreaMap from "../../../components/AreaMap";
import InputErrorMessage from "../../../components/InputErrorMessage";
import { formatFileName } from "../../../utils/format";
import { api, getAreaInfo } from "../../../api";
import { useEffect } from "react";

const AoiUpload = ({ aoiInfo, setAoiInfo, setError }) => {
  const { formatMessage } = useIntl();
  const [aoiError, setAoiError] = useState(null);
  const [uploadingFile, setUploadingFile] = useState(false);
  const [fileName, setFileName] = useState(null);

  const handleFileChange = async ([file]) => {
    setUploadingFile(true);

    setFileName(formatFileName(file.name));

    const formData = new FormData();
    formData.set("file_contents", file);
    await api
      .post("/b3_areas/search_aoi_file", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then(response => {
        setAoiError(null);

        getAreaInfo(response.data.area_id)
          .then(res => {
            setAoiInfo(res.data.result);
          })
          .catch(() => {
            setError(formatMessage({ id: "erro-api" }));
          });
      })
      .catch(err => {
        setAoiError(
          err?.response?.data?.message ||
            formatMessage({ id: "erro-inesperado-upload" })
        );
      });

    setUploadingFile(false);
  };

  const { getRootProps, getInputProps } = useDropzone({
    multiple: false,
    onDrop: handleFileChange
  });

  useEffect(() => {
    if (!aoiInfo) {
      setFileName(null);
    }
  }, [aoiInfo]);

  return (
    <>
      {aoiInfo ? (
        <AreaMap aoiInfo={aoiInfo} id="report-file" className="map" />
      ) : (
        <div
          id="report-file"
          {...getRootProps({
            className:
              "label" +
              (fileName || uploadingFile ? " selected" : "") +
              (aoiError ? " error" : "")
          })}
        >
          {uploadingFile ? (
            <>
              <div className="loader"></div>
              {fileName && `${formatMessage({ id: "Enviando" })} "${fileName}"`}
            </>
          ) : (
            <>
              <input
                type="file"
                onChange={handleFileChange}
                {...getInputProps()}
              />
              {fileName ? (
                <>
                  {aoiError ? (
                    <XCircle className="file-icon" />
                  ) : (
                    <File className="file-icon" />
                  )}
                  {fileName}
                </>
              ) : (
                <>
                  <FilePlus className="file-icon" />
                  {formatMessage({ id: "adicionar-arquivo" })}
                </>
              )}
            </>
          )}
        </div>
      )}
      {aoiError && <InputErrorMessage message={aoiError} />}
    </>
  );
};

export default AoiUpload;
